/**
 * A dónde lleva "ver los cursos" mientras el catálogo está oculto para el lanzamiento.
 *
 * El catálogo (`/courses`) existe y funciona, pero todavía no se muestra: hasta que se
 * publique, todo lo que decía "ver todos los cursos" tiene que aterrizar en la home, donde sí
 * están los cursos destacados.
 *
 * Vive en una constante y no repetido en cada `<Link>` por una razón concreta: hay casi treinta
 * lugares que apuntaban al catálogo, repartidos en veinte archivos entre la landing y el
 * carrito. Cambiarlos uno por uno significa que el día que el catálogo se publique haya que
 * acordarse de los treinta, y basta que se escape uno para que quede un link muerto. Así, ese
 * día se cambia ESTE valor a `/courses` y listo.
 *
 * Ojo: esto NO alcanza solo. Cubre la navegación dentro de la app, pero alguien puede entrar a
 * `/courses` de frente —un marcador, un link viejo, un resultado de Google—, y para eso está
 * el redirect del servidor en `server.js`. Las dos cosas se sacan juntas.
 */
export const CATALOG_PATH = "/";

